import React, { Component, createRef } from "react"
import ReactHtmlParser from "react-html-parser"
// import MeshComponent from '../House of Phenikaa 3D/MeshComponent'
import BannerIcon from "./BannerIcon"
import Circuit from "../Circuit"

import Api from "../Api"

import classes from "./Desktop.module.css"

class Ecosystem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      sections: {
        widgets: [],
      },
      isLoaded: false,
      isApiLoaded: false,
      selectedBox: null,
      activeBox: 0,
    }
    this.toggleHandlerEnter = this.toggleHandlerEnter.bind(this)
    this.getSectionDetail = this.getSectionDetail.bind(this)
    this.updateSelectedBox = this.updateSelectedBox.bind(this)
    this.scrollingHandlerBs = this.scrollingHandlerBs.bind(this)
    this.handleOverride = this.handleOverride.bind(this)
  }

  componentDidMount() {
    this.getSectionDetail()
    window.addEventListener("scroll", this.scrollingHandlerBs, true)
    this.handleOverride()
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollingHandlerBs, true)
  }

  bs_sec1_div1 = createRef()
  bs_sec1_div2 = createRef()

  handleOverride() {
    this.props.override(false)
  }

  scrollingHandlerBs() {
    // console.log(this.state.currentSection, this.state.darkLogo)
    if (this.bs_sec1_div1.current.getBoundingClientRect().bottom < this.bs_sec1_div1.current.getBoundingClientRect().height && this.bs_sec1_div1.current.getBoundingClientRect().bottom > -1) {
      this.props.updateLogo(true)
      // this.setState({
      //     currentSection: "Section1",
      //     darkLogo: false
      // })
    }
    //if(this.section2.current.getBoundingClientRect().y < 100 && this.section2.current.getBoundingClientRect().bottom > 100){
    if (this.bs_sec1_div2.current.getBoundingClientRect().bottom < this.bs_sec1_div2.current.getBoundingClientRect().height && this.bs_sec1_div2.current.getBoundingClientRect().bottom > -1) {
      this.props.updateLogo(false)
      // this.setState({
      //     currentSection: "bs_sec1_div1",
      //     darkLogo: true
      // })
    }
  }
  getSectionDetail() {
    const apiData = new Api()
    this.setState({ sections: [] }, () => {
      apiData
        .getSectionDetail()
        .then((result) => {
          this.setState({
            isApiLoaded: true,
          })
          const sections = result.data
          console.log(result.data)
          const widget = []
          result.data.widgets.forEach((item) => {
            widget.push({
              id: item.id,
              index: item.index,
              category: item.category,
              name: item.name,
              sections: item,
            })
          })
          sections.page = widget
          this.setState({
            sections: widget,
            isLoaded: true,
          })
        })
        .catch((error) => {
          // console.log(error);
          this.setState({
            isApiLoaded: true,
          })
        })
    })
  }

  updateSelectedBox(index) {
    this.setState({
      activeBox: index,
    })
  }

  toggleHandlerEnter = () => {
    this.setState((prevState) => {
      return {
        isOpen: !prevState.isOpen,
      }
    })
  }

  isBanner = (url) => {
    let content
    if (url !== "") {
      let type = [".png", ".jpg", ".jpeg"]
      // let result = url.every(i => type.toLowerCase().includes(i))
      // let mySet = new Set(url)
      let myArr = url.split()
      let result = myArr.some(i => type.includes(i))

      if (result) {
        content = <img className={classes.imgBanner} src={url} alt=''></img>
      } else {
        content = <video loop={true} autoPlay={true}>
          <source src={url} type='video/mp4' />
        </video>
      }
    } else {
      content = <img className={classes.imgBanner} src={require('../assets/default-image.svg')} alt=''></img>
    }
    return content
  }

  render() {
    const { dummy, sections } = this.state
    let titleBanner,
      imageBanner,
      contentSection,
      infoBoxes,
      videoPhenikaa,
      content = null
      if (this.state.isLoaded) {
      let count = 0
      sections.forEach((item) => {
        count = count + 1
        if (item.index === 1 && item.category === "Text") {
          item.sections.widget_contents.forEach((s) => {
            if (s.content !== "") {
              titleBanner = s.content
            }
          })
        } else if (item.index === 1 && item.category !== "Text") {
        }
        if (item.index === 2 && item.category === "Media") {
          item.sections.widget_contents.forEach((s) => {
            imageBanner = this.isBanner(s.file ? s.file : require("../assets/default-image.svg"))
          })
        } else if (item.index === 2 && item.category !== "Media") {
          imageBanner = <img className={classes.imageBanner} src={require('../assets/default-image.svg')} alt=''></img>
        }
        if (item.index === 3 && item.category === "Article") {
          contentSection = item.sections.widget_contents.map((s) => {
            return (
              <>
                <p className={[classes.titleContent2, classes.customMargin].join(" ")}>{s.title}</p>
                <p className={classes.content}>{ReactHtmlParser(s.content)}</p>
              </>
            )
          })
        } else if (item.index === 3 && item.category !== "Article") {
        }
        if (item.index === 4 && item.category === "Article") {
          infoBoxes = item.sections.widget_contents.map((s, index) => {
            // if (this.state.activeBox === index) {
            //   content = item.sections.widget_contents[index].content;
            // }
            if (this.state.activeBox === index) {
              var classtitle = classes.titleContentBold
              content = ReactHtmlParser(item.sections.widget_contents[index].content)
            }

            return (
              <div className={classes.wrapBox} onClick={(e) => this.updateSelectedBox(index)}>
                <div className={classes.boxBelow}>
                  <img src={s.assets[0] ? s.assets[0].file : null} alt='' />
                  <div
                    className={[classes.textBelow, classtitle].join(" ")}
                  // id={index}
                  >
                    <p>{s.title}</p>
                  </div>
                  {/* <span className={classes.content}>{ReactHtmlParser(s.content)}</span> */}
                </div>
              </div>
            )
          })
        } else if (item.index === 4 && item.category !== "Article") {
        }

        if (item.index === 5 && item.category === "Media") {
          videoPhenikaa = item.sections.widget_contents.map((s) => {
            return (
              <video className={classes.isvideo} controls loop={true} autoPlay='autoplay'>
                <source src={s.file} type='video/mp4' />
              </video>
            )
          })
        }
      })
    }

    let contentCore = this.state.isOpen ? <Circuit newStyle={classes.isAbsolute} /> : <Circuit />

    // let houseOfPhenikaa = <HouseofPhenikaa />
    let houseOfPhenikaa = videoPhenikaa

    return (
      <div id='sectionEcosystem' className={["section-ecosystem", classes.sectionEcosystem].join(" ")}>
        <div ref={this.bs_sec1_div1} className={classes.banner}>
          {/* <img className={classes.imgBanner} src={imageBanner} alt=''></img> */}
          {imageBanner}
          <div className={classes.bannerIcon}>
            <BannerIcon />
          </div>
          <div className={classes.bannerContent}>
            <p className={[classes.titleBanner, classes.animate].join(" ")}>{titleBanner}</p>
            <div className={[classes.underlineAnimate]}></div>
          </div>
        </div>
        <div ref={this.bs_sec1_div2} className={["container", classes.cusTom].join(" ")}>
          <div className={[classes.boxContent].join(" ")}>
            <div className={["d-flex", classes.pp].join(" ")}>
              <div className={classes.boxLeft}>{contentSection}</div>
              <div className={classes.boxRight}>{houseOfPhenikaa}</div>
            </div>
            <div className={classes.infoBoxes}>{infoBoxes}</div>
            <div className={classes.content}>{content}</div>
          </div>
        </div>
      </div>
    )
  }
}

export default Ecosystem
